module.exports = __webpack_public_path__ + "static/media/sopt30kz.4b287fa9.pdf";